module.exports = __webpack_public_path__ + "img/prediction_generate_features.87ee69bc.png";